import React from "react"
import PropTypes from "prop-types"

import trackCustomEventTrigger from "utils/trackCustomEventTrigger"
import trackingCategoriesHelper from "utils/trackingCategoriesHelper"

import P from "components/atoms/P"
import Icon from "components/atoms/Icon"
import BtnLink from "components/atoms/BtnLink"

import {
  tabItemStyles,
  tabTextStyles,
  StyledIcon,
  StyledNavList,
} from "./NavList.styles"

const NavList = ({
  navContent,
  onChange,
  selected,
  className,
  bannerHeight,
}) => {
  const changeActive = (element) => onChange(element.id)

  return (
    <StyledNavList className={className} bannerHeight={bannerHeight}>
      {navContent.map((element) => (
        <BtnLink
          key={element.label}
          to={element.path}
          linkStyles={tabItemStyles}
          activeClassName="active"
          onClick={() => {
            changeActive(element)
            trackCustomEventTrigger({
              category: trackingCategoriesHelper.PROJECT_NAVIGATION,
              action: "Click",
              label: `${trackingCategoriesHelper.PROJECT_NAVIGATION} button(${element.label})`,
            })
          }}
          className={`${selected && element.id === selected && "active"} ${
            element.icon
          }`}
          role={element.role || "link"}
        >
          <StyledIcon>
            <Icon icon={element.icon} name={element.icon} key={element.icon} />
          </StyledIcon>
          <P extraStyles={tabTextStyles}>{element.label}</P>
        </BtnLink>
      ))}
    </StyledNavList>
  )
}

NavList.propTypes = {
  navContent: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      path: PropTypes.string,
      icon: PropTypes.oneOfType([
        PropTypes.shape({
          original: PropTypes.string,
          large: PropTypes.string,
          medium: PropTypes.string,
          small: PropTypes.string,
        }),
        PropTypes.string,
      ]),
      role: PropTypes.string,
      id: PropTypes.string,
      className: PropTypes.string,
    })
  ).isRequired,
  onChange: PropTypes.func,
  selected: PropTypes.string,
  className: PropTypes.string,
  bannerHeight: PropTypes.number,
}
NavList.defaultProps = {
  onChange: () => {},
  selected: null,
  className: "",
  bannerHeight: 0,
}
export default NavList
